import { Link } from "react-router-dom";

const Navigation = () => (
  <header className="w-full flex justify-center py-10 space-x-2 sm:space-x-10 text-xl sm:text-3xl text-black font-semibold">
    <h1 className="w-1/3">
      <Link to={"/"}>Three Doors Problem</Link>
    </h1>
    <div className="grid grid-cols-2 gap-3">
      <Link className="button-primary" to={"/manual"}>
        Manual
      </Link>
      <Link className="button-primary" to={"/auto"}>
        Auto
      </Link>
    </div>
  </header>
);

export default Navigation;